import React, { useEffect } from 'react'

import { Controller, useForm, SubmitHandler } from 'react-hook-form'

import { useTranslation } from 'next-i18next'

import { EnrollmentsFields } from '@dentalux/security'

import { Grid } from '@mui/material'

import { yupResolver } from '@hookform/resolvers/yup'
import { Continue } from 'src/components/AuthLayout/components/Continue/Continue'
import { EmailInputFilled } from 'src/components/inputs'
import { DataTestIds } from 'src/config/dataTestIds'

import * as S from './RegistrationForm.styles'
import { useRegistrationFormValidation } from './RegistrationForm.validation'

type Props = {
  onSubmit: SubmitHandler<EnrollmentsFields>
  initialValues: Partial<EnrollmentsFields>
  isLoading?: boolean
}

const RegistrationForm = ({ onSubmit, isLoading, initialValues }: Props) => {
  const { t } = useTranslation()
  const schema = useRegistrationFormValidation()

  const {
    control,
    handleSubmit,
    formState: { errors, isValid, touchedFields },
    reset,
  } = useForm<EnrollmentsFields>({
    resolver: yupResolver(schema),
    mode: 'onChange',
  })

  useEffect(() => {
    if (Object.values(touchedFields).length === 0) {
      reset({ ...initialValues })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues, reset])

  return (
    <S.Form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Grid container spacing={2}>
        <S.GridItem>
          <Controller
            name="email"
            control={control}
            defaultValue=""
            render={({ field }) => {
              return (
                <EmailInputFilled
                  label={t('b2c.registration_form.emailInput')}
                  dataTestId={DataTestIds.RegistrationEmail}
                  name={field.name}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  value={field.value}
                  inputError={touchedFields.email && errors.email}
                  required
                />
              )
            }}
          />
        </S.GridItem>
      </Grid>
      <Continue data-testid={DataTestIds.SubmitButton} disabled={!isValid || isLoading}>
        {t('b2c.registration_form.send')}
      </Continue>
    </S.Form>
  )
}

export default RegistrationForm
